export function ActiveBadge({ active }: { active: boolean }) {
  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
        active ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-600"
      }`}
    >
      {active ? "Attivo" : "Non attivo"}
    </span>
  );
}
